var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16.8,
    viewBox: "0 0 24 16.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-friends",
    "data-name": "Icon awesome-user-friends",
    d: "M7.2,10.65A4.2,4.2,0,1,0,3,6.45,4.2,4.2,0,0,0,7.2,10.65Zm2.88,1.2H9.769a5.8,5.8,0,0,1-5.137,0H4.32A4.321,4.321,0,0,0,0,16.17v1.08a1.8,1.8,0,0,0,1.8,1.8H12.6a1.8,1.8,0,0,0,1.8-1.8V16.17A4.321,4.321,0,0,0,10.08,11.85ZM18,10.65a3.6,3.6,0,1,0-3.6-3.6A3.6,3.6,0,0,0,18,10.65Zm1.8,1.2h-.142a4.729,4.729,0,0,1-3.315,0H16.2a4.165,4.165,0,0,0-2.089.578A5.488,5.488,0,0,1,15.6,16.17v1.44c0,.083-.019.161-.023.24H22.2a1.8,1.8,0,0,0,1.8-1.8,4.2,4.2,0,0,0-4.2-4.2Z",
    transform: "translate(0 -2.25)",
    fill: "#fab700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/usersIcon.c44b478273dd54db365c895c13b67767.svg";
export { ForwardRef as ReactComponent };